/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_3_TInputs */

const en_cp_jr_3_t = /** @type {(inputs: Cp_Jr_3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo Day + Build Challenge`)
};

const id_cp_jr_3_t = /** @type {(inputs: Cp_Jr_3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo Day + Build Challenge`)
};

/**
* | output |
* | --- |
* | "Demo Day + Build Challenge" |
*
* @param {Cp_Jr_3_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_3_t = /** @type {((inputs?: Cp_Jr_3_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_3_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_3_t(inputs)
	return en_cp_jr_3_t(inputs)
});